import React, { Component } from 'react'

import { searchTextSelector } from './MedicalTestApi'
import debounce from 'debounce-promise'
import Select from 'react-select'

interface MedicalTestSearchProps {
  onSelect: any
}

interface MedicalTestSearchState {
  options: any[]
  isLoading: boolean
}

export default class MedicalTestSearch extends Component<MedicalTestSearchProps> {
  debouncedLoadOptions: (inputValue: any) => any
  inputValue: string
  page: number

  constructor(props: Readonly<MedicalTestSearchProps>) {
    super(props)
    const wait = 1000 // milliseconds
    this.inputValue = ''
    this.page = 1
    const loadOptions = (inputValue: any) => this.getOptions(inputValue)
    this.debouncedLoadOptions = debounce(loadOptions, wait, {
      leading: false,
    })
  }

  state: MedicalTestSearchState = {
    options: [],
    isLoading: false,
  }

  getOptions = async (inputValue: string) => {
    return new Promise((resolve) => {
      const answer = searchTextSelector(inputValue, this.page)
      resolve(answer)
    })
  }

  componentDidMount() {
    window.sessionStorage.removeItem('medical_tests_list')
    this.setState({ isLoading: true })
    this.debouncedLoadOptions(this.inputValue).then((result: any) =>
      this.setState({
        options: result,
        isLoading: false,
      }),
    )
  }

  onInputChange = (inputValue: string) => {
    this.inputValue = inputValue
    window.sessionStorage.removeItem('medical_tests_list')
    this.page = 1
    this.setState({ isLoading: true })
    this.debouncedLoadOptions(this.inputValue).then((result: any) => {
      this.setState({
        options: result,
        isLoading: false,
      })
    })
  }

  onChange = (event: any) => {
    this.props.onSelect(event)
  }

  onMenuScrollToBottom = () => {
    this.page = this.page + 1
    this.setState({ isLoading: true })
    this.debouncedLoadOptions(this.inputValue).then((result: any) =>
      this.setState({
        options: result,
        isLoading: false,
      }),
    )
  }
  styles = {
    option: (css: any) => ({ ...css, textAlign: 'right', direction: 'rtl' }),
  }
 
  render() {
    const { options, isLoading } = this.state
    
    return (
      <div>
        <Select
          className="react-select"
          classNamePrefix="react-select"
          isDisabled={false}
          isLoading={isLoading}
          isSearchable={true}
          options={options}
          onMenuScrollToBottom={this.onMenuScrollToBottom}
          onInputChange={this.onInputChange}
          onChange={this.onChange}
          menuPosition={'fixed'}
          styles={this.styles}/>    
      </div>
    )
  }
}
